/** WI 34963: a Viewpoint purchase order (bPOHD) offered by the NCR form's PO typeahead. */
export interface VpPurchaseOrder {
  /** The PO number, e.g. "26-1001". The saved answer. */
  po: string;
  description: string;
  /** The PO company. */
  poCo: number;
  /** ISO date the PO was ordered, or null. */
  orderDate: string | null;
  /** bPOHD.Status: 0 open, 1 complete, 2 closed, 3 pending. */
  status: number;
  vendorGroup: number;
  /** The vendor number. Picking the PO pushes it to the NCR vendor control. */
  vendor: number;
  vendorName: string;
  /** "number description (vendor)", the label both platforms render. */
  name: string;
}
